import { cn } from "@/lib/utils";
import { contactIconMap } from "@/data/contact";
import type { ContactItem } from "@/types/models";

interface ContactCardProps {
  item: ContactItem;
  className?: string;
  variant?: "light" | "dark";
}

export function ContactCard({ item, className, variant = "light" }: ContactCardProps) {
  const Icon = contactIconMap[item.iconName];

  return (
    <a
      href={item.href}
      target={item.isExternal ? "_blank" : undefined}
      rel={item.isExternal ? "noopener noreferrer" : undefined}
      className={cn(
        "flex flex-col items-center text-center p-6 rounded-xl transition-colors duration-200",
        variant === "light"
          ? "bg-pureWhite/10 hover:bg-pureWhite/20"
          : "bg-pureWhite rounded-xl shadow-sm hover:shadow-md hover:-translate-y-0.5",
        className
      )}
    >
      <Icon
        size={28}
        className={variant === "light" ? "text-softSky mb-3" : "text-oceanBlue mb-3"}
        aria-hidden="true"
      />
      <span
        className={cn(
          "text-sm mb-1",
          variant === "light" ? "text-pureWhite/60" : "text-textMuted"
        )}
      >
        {item.label}
      </span>
      <span
        className={cn(
          "font-medium",
          variant === "light" ? "text-pureWhite" : "text-textBody"
        )}
      >
        {item.value}
      </span>
    </a>
  );
}
